import { useTheme } from "../theme";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="flex items-center gap-1 rounded-lg bg-[var(--color-surface-2)] p-0.5 text-[11px] font-mono font-medium">
      <button
        onClick={() => setTheme("light")}
        className={
          "rounded-md px-2 py-1 transition-colors " +
          (theme === "light"
            ? "bg-[var(--color-chip-yellow)] text-[#1f1f1f]"
            : "text-[var(--color-fg-muted)] hover:text-[var(--color-fg)]")
        }
        title="Архив · светлая тема"
      >
        АП
      </button>
      <button
        onClick={() => setTheme("dark")}
        className={
          "rounded-md px-2 py-1 transition-colors " +
          (theme === "dark"
            ? "bg-[var(--color-brand)] text-white"
            : "text-[var(--color-fg-muted)] hover:text-[var(--color-fg)]")
        }
        title="Меш · тёмная тема"
      >
        МШ
      </button>
    </div>
  );
}
